module.exports = __webpack_public_path__ + "img/logo-7217.82c55a40.png";